import React, { Component } from 'react';
import { DatePicker, Select, Checkbox, Radio, InputNumber, Input, message } from 'antd';
import EditableTable from '../common/EditableTable';
import SearchRetrieveBtn from '../common/SearchRetrieveBtn';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import UploadFile from '../common/UploadFile';
import ExportUtil from  '../../common/ExportUtil'
import API_URL from  '../../common/url'
import moment from 'moment';

const { Option } = Select;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { MonthPicker } = DatePicker;

// TODO: 将字段拆分成单独的组件（可以维护自己的状态）
class FormList extends Component {
    state = {
        selectModalVisibe: false,
    }

    // 必填校验：由父组件调用触发
    validate = () => {
        const { columns } = this.props;
        const loopValidate = function (columns) {
            let allFieldHasValue = true;
            for (let i = 0; i < columns.length; i++) {
                const column = columns[i];
                const { name, type, children, typeProperty, rules } = column;
                const { display = true, required, msg } = rules || {};
                const { value } = typeProperty || {};
                if (display) {
                    if (children) {
                        allFieldHasValue = loopValidate(children);
                        if (!allFieldHasValue) break;
                    } else if (required) {
                        if (!value || (Array.isArray(value) && value.length === 0)) {
                            if (type === 'inputNumber' && value !== 0) {
                                const msgInfo = msg || ('请输入' + name);
                                message.warning(`${msgInfo}!`);
                                allFieldHasValue = false;
                            } else if (type !== 'inputNumber' && type !== 'custom') {
                                const msgInfo = msg || (
                                    ((type === 'input' && '请输入')
                                    || (type === 'textArea' && '请输入')
                                    || (type === 'table' && '请添加')
                                    || '请选择') + name);
                                message.warning(`${msgInfo}!`);
                                allFieldHasValue = false;
                            } else if (type === 'custom') {
                                message.warning(msg);
                                allFieldHasValue = false;
                            }
                            if (!allFieldHasValue) break;
                        } else if (type === 'table') {
                            allFieldHasValue = loopValidateTable(typeProperty);
                            if (!allFieldHasValue) break;
                        }
                    }
                }
            }
            return allFieldHasValue;
        };
        const loopValidateTable = (perperty) => {
            let allRowshasValue = true;
            const { value = [], list } = perperty;
            for (let i = 0; i < value.length; i++) {
                const data = value[i];
                for (let j = 0; j < list.length; j++) {
                    const item = list[j];
                    const { name, key, type, rules = {} } = item;
                    const { required, msg } = rules;
                    if (required) {
                        if (!data[key]) {
                            if (type === 'inputNumber' && data[key] !== 0) {
                                const msgInfo = msg || ('请输入' + name);
                                message.warning(`${msgInfo}!`);
                                allRowshasValue = false;
                            } else if (type !== 'inputNumber') {
                                const msgInfo = msg || (
                                    ((type === 'input' && '请输入')
                                    || (type === 'textArea' && '请输入')
                                    || '请选择') + name);
                                message.warning(`${msgInfo}!`);
                                allRowshasValue = false;
                            }
                            if (!allFieldHasValue) break;
                        }
                    }
                }
            }
            return allRowshasValue;
        }
        return loopValidate(columns);
    }

    switchSelectModalDisplay = (selectModalVisibe) => {
        this.setState({ selectModalVisibe });
    }

    handleTextAreaChange = (value, column) => {
        const { key, name, type, typeProperty = {} } = column;
        const { limit } = typeProperty;
        if (limit) {
            if (value && (value.length > limit)) {
                message.warning(`${name}最大可输入${limit}！`);
                return;
            }
        }
        this.props.onChange(value, key, type);
    }

    getComment = (key, canEdit, comment) => {
        const result = [];
        const { value, style = {} } = comment || {};
        result.push(<div className="comment-left" key="comment-left">{!!comment && '备注:'}</div>);
        result.push(
            <div className="comment-right" key="comment-right">
                {
                    !!comment &&
                    (
                        canEdit ?
                            <Input
                                style={style}
                                value={value}
                                placeholder="请输入"
                                onChange={(e) => onChange(e.target.value, key, 'comment')}
                            />
                        :
                            value
                    )
                }
            </div>
        );
        return result;
    }

    renderDomByType = (column) => {
        const { onChange } = this.props;
        const { key, name, type, typeProperty = {}, comment, rules = {}, suffix } = column;
        const { required, display = true, colon = true } = rules;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        if (!display) {
            return null;
        }
        if (type === 'input') {
            const { value, style = {}, unit = '', canEdit = true, placeholder = '请输入' } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <Input
                                    style={style}
                                    value={value}
                                    placeholder={placeholder}
                                    onChange={(e) => onChange(e.target.value, key, type)}
                                />
                            :
                                value
                        }
                        {unit ? <span style={{marginLeft: 6}}>{unit}</span> : ''}
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'inputNumber') {
            const { value, style = {}, unit = '', canEdit = true, placeholder = '请输入', ...rest } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <InputNumber
                                    value={value}
                                    style={style}
                                    placeholder={placeholder}
                                    {...rest}
                                    onChange={(value) => onChange(value, key, type)}
                                />
                            :
                                value
                        }
                        {unit ? <span style={{marginLeft: 6}}>{unit}</span> : ''}
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'textArea') {
            const { value, limit, style = {}, rows = 3, canEdit = true, placeholder = '请输入' } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <TextArea
                                    rows={rows}
                                    style={style}
                                    value={value}
                                    placeholder={placeholder}
                                    onChange={(e) => this.handleTextAreaChange(e.target.value, column)}
                                />
                            :
                                value
                        }
                        { limit && <p style={{ ...style, float: 'right', textAlign:'right', color:'#ccc' }}>{(value && value.length) || 0}/{limit}</p>}
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'select') {
            const { list, value, style = {}, canEdit = true, disabled = false, mode = '', placeholder } = typeProperty;
            const options = list.map(i => <Option key={i.value} title={i.label}>{i.label}</Option>);
            let newValue = value ? String(value) : undefined;
            if (mode === 'multiple') {
                newValue = value || [];
            }
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <Select
                                    mode={mode}
                                    style={style}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    value={newValue}
                                    allowClear={true}
                                    onChange={value => onChange(value, key, type)}
                                >
                                    {options}
                                </Select>
                            :
                                value
                        }
                        { suffix }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'radio') {
            const { list, value, style = { width: '100%' }, canEdit = true, disabled = false } = typeProperty;
            const options = list.map(i => <Radio key={i.value} value={i.value}>{i.label}</Radio>);
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <RadioGroup
                                    value={value}
                                    style={style}
                                    disabled={disabled}
                                    onChange={e => onChange(e.target.value, key, type)}
                                >
                                    {options}
                                </RadioGroup>
                            :
                                value
                        }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'checkBox') {
            const { list, value, style = { width: '100%' }, canEdit = true } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <CheckboxGroup
                                    options={list}
                                    value={value}
                                    style={style}
                                    onChange={checkedValues => onChange(checkedValues, key, type)}
                                />
                            :
                                value
                        }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'searchRetrieve') {
            const { value, canEdit = true, ...rest } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <SearchRetrieve
                                    {...rest}
                                    value={value}
                                    onChange={option => onChange(option, key, type)}
                                />
                            :
                                value
                        }
                        { suffix }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'searchRetrieveBtn') {
            const { value, content, canEdit = true, ...rest } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <div>
                                    <SearchRetrieveBtn
                                        {...rest}
                                        onChange={option => onChange(option, key, type)}
                                    />
                                    { content }
                                </div>
                            :
                                value
                        }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'selectModal') {
            const { value, style = {}, SelectModal, content, canEdit = true, modalProps = {} } = typeProperty;
            const { selectModalVisibe } = this.state;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <div>
                                    <Input
                                        placeholder="请选择"
                                        style={style}
                                        onClick={() => this.switchSelectModalDisplay(true)}
                                    />
                                    { content }
                                    <SelectModal
                                        value={value}
                                        visible={selectModalVisibe}
                                        onChange={value => onChange(value, key, type)}
                                        switchDisplay={this.switchSelectModalDisplay}
                                        {...modalProps}
                                    />
                                </div>
                            :
                                value
                        }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'datePicker' || type === 'monthPicker') {
            const { value, style = {}, allowClear = true, canEdit = true, disabled = false, ...rest } = typeProperty;
            const Comp = type === 'datePicker' ? DatePicker : MonthPicker;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <Comp
                                    placeholder="请选择"
                                    allowClear={allowClear}
                                    style={style}
                                    disabled={disabled}
                                    value={value ? moment(value) : null}
                                    {...rest}
                                    onChange={(date, dateString) => onChange(dateString, key, type)}
                                />
                            :
                                value
                        }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'upload') {
            const { value = [], params = {}, canEdit = true, ...rest } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {
                            canEdit ?
                                <UploadFile
                                    data={{
                                        ...params,
                                        path: Date.now(),
                                    }}
                                    number={30}
                                    fileList={value}
                                    {...rest}
                                    onChange={(file, fileList) => onChange(fileList, key, type)}
                                />
                            :
                                value
                        }
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'table') {
            const { value = [], list, scrollY, canEdit = true } = typeProperty;
            return (
                <li className="modal-item" key={name}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        <EditableTable
                            columns={list}
                            canEdit={canEdit}
                            scrollY={scrollY}
                            dataSource={value}
                            onChange={dataSource => onChange(dataSource, key, type)}
                        />
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'custom') {
            const { content, canEdit = true } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">{content}</div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        } else if (type === 'text') {
            const { value, unit = '', canEdit = true } = typeProperty;
            const { format = v => v } = rules;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {format(value)}
                        {unit ? <span style={{marginLeft: 6}}>{unit}</span> : ''}
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        }else if (type === 'textList') {
            const { value, unit = '', canEdit = true } = typeProperty;
            return (
                <li className="modal-item" key={key}>
                    <div className="item-left">{required && asterisk}{name}{colon && ':'}</div>
                    <div className="item-right">
                        {value?value.map((file)=>{
                            return (<div key={file.fileMetaId}>
                                <a onClick={() => this.download({ fileMetaId:file.fileMetaId })}>{file.fileName}</a>
                            </div>)
                        }):''}
                    </div>
                    { this.getComment(key, canEdit, comment) }
                </li>
            )
        }
    }
    // 下载文件
    download = (params) => {
        ExportUtil.export(params, null, API_URL.contract.downloadJdeCodeEnclosure);
        message.success('正在下载中!')
    }

    getContentList = (columns) => {
        const result = [];
        (columns || []).forEach(column => {
            const { name, type, children } = column;
            if (type === 'title') {
                result.push(
                    <li className="modal-item" key={name}>
                        <div className="title">{name}</div>
                    </li>
                );
                result.splice(result.length, 0, this.getContentList(children));
            } else {
                result.push(this.renderDomByType(column));
            }
        });
        return result;
    }

    render() {
        const { columns, className = '' } = this.props;
        return (
            <div className={`modal-content ${className}`}>
                <ul className="modal-list">
                    {this.getContentList(columns)}
                </ul>
            </div>
        );
    }
}

export default FormList;


// WEBPACK FOOTER //
// ./src/components/basicElement/FormList.js